import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {AuthenticationService} from '../shared/service/authentication.service';
import {TranslatePipe} from '@ngx-translate/core';
import {ClickDownDirective} from '../shared/directive/click-down.directive';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'ucs-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslatePipe,
    ClickDownDirective,
    FormsModule
  ]
})
export class LandingPageComponent implements OnInit {
  saveSelection: boolean = false;
  authProvider: string;
  private readonly authenticationService = inject(AuthenticationService);

  ngOnInit() {
    this.authProvider = JSON.parse(localStorage.getItem('ucs-auth-provider'));
    if (this.authProvider) {
      this.saveSelection = true;
    }
  }

  login(target: string) {
    this.authenticationService.login(target);
    if (this.saveSelection) {
      localStorage.setItem('ucs-auth-provider', JSON.stringify(target));
    }
  }

  toggleSaveSelection() {
    this.saveSelection = !this.saveSelection;
    if (!this.saveSelection) {
      this.authProvider = undefined;
      localStorage.removeItem('ucs-auth-provider');
    }
  }
}
